export default __webpack_public_path__ + "static/media/circle-plus.0d92bc0d.svg";